export default __webpack_public_path__ + "static/media/board.018f5c34.svg";